var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 85.5C16.5417 85.5 14.5806 84.6847 12.95 83.0542C11.3194 81.4236 10.5028 79.4611 10.5 77.1667V18.8333C10.5 16.5417 11.3167 14.5806 12.95 12.95C14.5833 11.3194 16.5444 10.5028 18.8333 10.5H77.1667C79.4583 10.5 81.4208 11.3167 83.0542 12.95C84.6875 14.5833 85.5028 16.5444 85.5 18.8333V77.1667C85.5 79.4583 84.6847 81.4208 83.0542 83.0542C81.4236 84.6875 79.4611 85.5028 77.1667 85.5H18.8333ZM18.8333 77.1667H77.1667V18.8333H18.8333V77.1667ZM23 68.8333H73L57.375 48L44.875 64.6667L35.5 52.1667L23 68.8333Z",
    fill: "#51210D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.87ae4bb5a43939baebf4abcd38b05251.svg";
export { ForwardRef as ReactComponent };